import { render, staticRenderFns } from "./PolizasSGListView.vue?vue&type=template&id=47c10136&"
import script from "./PolizasSGListView.vue?vue&type=script&lang=js&"
export * from "./PolizasSGListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports